import {ILanguageListData} from 'src/shared/services/configuration/language/dtos/language-list';

export const Language = (data: ILanguageListData) => {
  return {
    Label: data.Name,
    Value: data.Id,
  };
};
